import { Star, ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./shared";

const GOOGLE_URL = "https://g.page/r/CYyABP5GPx1cEAI/review";

export const Avis = () => (
  <section className="bg-nuit py-20 lg:py-28" data-testid="avis-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-10">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <Overline light>Avis clients</Overline>
          <h2 className="font-display mt-4 text-3xl font-medium leading-tight tracking-tight text-white sm:text-4xl">
            La confiance se prouve sur le terrain
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-white/65">
            Rosset Conciergerie &amp; Services est présent sur Google. Les avis des PPE, régies,
            propriétaires et particuliers qui nous confient leurs biens y seront publiés —
            de vrais retours, rien d'inventé.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="border border-lagoon/25 bg-white/5 p-8 lg:p-10">
            <div className="flex gap-1.5" aria-hidden="true">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-6 w-6 text-lagoon" fill="currentColor" strokeWidth={0} />
              ))}
            </div>
            <p className="font-display mt-5 text-xl font-medium leading-snug text-white">
              Vous avez travaillé avec nous ?
            </p>
            <p className="mt-3 text-sm leading-relaxed text-white/60">
              Votre avis aide les propriétaires et les PPE du Valais à choisir un partenaire
              sérieux — et il prend moins d'une minute.
            </p>
            <a
              href={GOOGLE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="avis-google-button"
              className="group mt-7 inline-flex items-center gap-2 rounded-full bg-lagoon px-7 py-4 text-sm font-bold uppercase tracking-[0.12em] text-nuit transition-colors duration-300 hover:bg-white"
            >
              Laisser un avis sur Google
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
